// src/components/Resenas.jsx

const resenas = [
  {
    id: 1,
    nombre: "Pablo S.",
    texto: "Muy recomendable, Walter es muy amable y te explica todo el proceso!",
    estrellas: 5,
  },
  {
    id: 2,
    nombre: "Santiago S.",
    texto: "Trabajo de alta calidad, cuidando todos los detalles.",
    estrellas: 5,
  },
  {
    id: 3,
    nombre: "Ignacio D.",
    texto: "MIL PUNTOS!! Un genio Walter y todos los chicos. Muy bien atendido siempre con muy buena onda y buena predisposición haciendo todo para que el vehículo quede como si fuera de ellos. Una experiencia excelente. Super recomendable.",
    estrellas: 5,
  },
];

export default function Resenas() {
  return (
    <section className="resenas">
      <h2>RESEÑAS</h2>
      <div className="grid-resenas">
        {resenas.map((resena) => (
          <div className="card-resena" key={resena.id}>
            <div className="estrellas">
              {"⭐".repeat(resena.estrellas)}
            </div>
            <p className="texto-resena">"{resena.texto}"</p>
            <p className="nombre-resena">– {resena.nombre}</p>
          </div>
        ))}
      </div>

      <a
        className="btn-ver-mas"
        href="https://www.google.com/maps/place/Detailing+Center+(ejemplo)/@-31.000000,-64.000000,17z"
        target="_blank"
        rel="noopener noreferrer"
      >
        Ver más reseñas en Google
      </a>
    </section>
  );
}
